import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useEffect } from 'react';

var initialConfig = {
  childList: true,
  attributes: true
};
function useMutationObserver(_ref) {
  var target = _ref.target,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    onChange = _ref.onChange;
  useEffect(function () {
    if (!target.current) {
      return;
    }
    var observer = new MutationObserver(function () {
      return onChange === null || onChange === void 0 ? void 0 : onChange();
    });
    observer.observe(target.current, _objectSpread2(_objectSpread2({}, initialConfig), config));
    return function () {
      return observer.disconnect();
    };
  }, []);
}

export { useMutationObserver };
//# sourceMappingURL=useMutationObserver.js.map
